import { useEffect, useRef } from 'react';
import { useFormikContext } from 'formik';
import { Card } from 'react-bootstrap';
import { FetchAvailableForms } from './FetchAvailableForms';
import './lease-form.scss'

const AttachPropertyForms = () => {
    const leaseFormRef = useRef(null);
    const formik = useFormikContext();
    return (
        <>
            <Card className="shadow-lg p-2 lease-form mb-10" style={{ backgroundColor: 'white' }}>
                <Card.Body ref={leaseFormRef}>
                    <div className="mb-4 lease-step">
                        <FetchAvailableForms formik={formik} />
                    </div>
                </Card.Body>
            </Card >
        </>
    );
};

export { AttachPropertyForms };
